import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { Layout, Form, Button, Card, Input } from 'antd';
import { UserOutlined, LockOutlined, LoadingOutlined } from '@ant-design/icons';
import { WrappedFormUtils } from "@ant-design/compatible/lib/form/Form"
import Eshops from '../../components/Query/Eshops';
import Auth from '../../components/Query/Auth';

import './Login.css';
import AuthService from 'src/services/AuthService';

interface LoginInterface {
  form: WrappedFormUtils;
}

interface ILoginState {
  login: boolean;
  email: string;
  password: string;
  error: any;
}

export default class Login extends React.Component<LoginInterface, ILoginState> {

  constructor(props: any) {
    super(props);

    this.state = {
      login: AuthService.GetInstance().loggedIn,
      email: '',
      password: '',
      error: undefined,
    };
  
    this.onSuccess = this.onSuccess.bind(this);
    this.onError = this.onError.bind(this);
  }

  onSuccess(data: any) {
    this.setState({
      login: true
    });
  }

  onError(error: any) {
    this.setState({
      error: error
    });
  }

  render() {
    return (
      <div className="Login">
        <Eshops>
          {({ eshops }: any) => (
            <div>
              {this.state.login &&
                eshops.eshops && <Redirect to={`/${eshops.eshops[0].domain}/application/dashboard`} />}
            </div>
          )}
        </Eshops>
        <Layout>
          <Layout.Content>
            <Card style={{ width: 500 }}>
              <p style={{ textAlign: 'center', fontWeight: 'bold' }}>
                {process.env.REACT_APP_PROJECT_NAME} ~ Backoffice
              </p>
              <Auth onError={this.onError} onSuccess={this.onSuccess}>
                {(data: any) => (
                  <Form
                    onFinish={e => {
                      data.login({
                        variables: {
                          email: this.state.email,
                          password: this.state.password,
                          type: 'backoffice'
                        }
                      });
                    }}
                    className="login-form"
                  >
                    <Form.Item>
                      <Input
                        prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                        name={'email'}
                        value={this.state.email}
                        onChange={e => this.setState({ email: e.target.value })}
                        placeholder="E-mail"
                      />
                    </Form.Item>
                    <Form.Item>
                      <Input
                        prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                        name={'password'}
                        type="password"
                        value={this.state.password}
                        onChange={e => this.setState({ password: e.target.value })}
                        placeholder="Password"
                      />
                    </Form.Item>
                    <Form.Item>
                      <b style={{ color: 'red' }}>
                        {(this.state as any).error && 'Wrong email or password'}
                      </b>

                      <Button type="primary" htmlType="submit" className="login-form-button">
                        {this.state.login && (
                          <LoadingOutlined style={{ fontSize: 24 }} spin={true} />
                        )}
                        Log in
                      </Button>
                    </Form.Item>
                  </Form>
                )}
              </Auth>
            </Card>
          </Layout.Content>
        </Layout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Login/index.tsx